// extracted by mini-css-extract-plugin
export default {"footerWrapper":"Footer_footerWrapper__5ytYm","lime":"Footer_lime__4DJBE","content":"Footer_content__I-04K"};